import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const DeleteConfirmModal = ({
  show,
  onHide,
  onConfirm,
  submitting = false,
  itemName = "",
}) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex={-1}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={(e) => {
        if (e.target === e.currentTarget && !submitting) onHide();
      }}
    >
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content radius-16 bg-base border-0 shadow-lg">
          {/* Header */}
          <div
            className="modal-header py-20 px-24 border-0"
            style={{
              background: "linear-gradient(135deg, #fef2f2, #fee2e2)",
              borderBottom: "3px solid #ef444430",
            }}
          >
            <div className="d-flex align-items-center gap-12">
              <div className="w-40-px h-40-px bg-danger-50 d-flex align-items-center justify-content-center radius-10">
                <Icon
                  icon="mdi:alert-outline"
                  className="text-danger-600"
                  style={{ fontSize: "20px" }}
                />
              </div>
              <h5 className="modal-title fw-semibold mb-0">Eliminar actividad</h5>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={onHide}
              disabled={submitting}
            />
          </div>

          {/* Body */}
          <div className="modal-body px-24 py-20 text-center">
            <Icon
              icon="mdi:trash-can-outline"
              style={{ fontSize: "48px", color: "#ef4444" }}
            />
            <p className="mt-12 mb-8 fw-medium">
              ¿Estás seguro de eliminar esta actividad?
            </p>
            {itemName && (
              <p className="text-secondary-light text-sm mb-0">
                <strong>"{itemName}"</strong>
              </p>
            )}
            <p className="text-secondary-light text-xs mt-8 mb-0">
              Esta acción no se puede deshacer.
            </p>
          </div>

          {/* Footer */}
          <div className="modal-footer py-16 px-24 border-0 d-flex justify-content-center gap-8">
            <button
              type="button"
              className="btn btn-outline-secondary radius-10 px-16"
              onClick={onHide}
              disabled={submitting}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-danger d-flex align-items-center gap-8 radius-10 px-16"
              onClick={onConfirm}
              disabled={submitting}
            >
              {submitting ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" />
                  <span>Eliminando...</span>
                </>
              ) : (
                <>
                  <Icon icon="mdi:trash-can-outline" style={{ fontSize: "18px" }} />
                  <span>Eliminar</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
